module.exports = __webpack_public_path__ + "img/product-placeholder-46.3ce87c5.png";